import { render } from "./boxFilesModal.vue?vue&type=template&id=737af3ae&scoped=true"
import script from "./boxFilesModal.vue?vue&type=script&lang=js"
export * from "./boxFilesModal.vue?vue&type=script&lang=js"

import "./boxFilesModal.vue?vue&type=style&index=0&id=737af3ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737af3ae"]])

export default __exports__